export const SCREEN_WIDTHS = {
    MOBILE: 767,
    TABLET: 1023,
    DESKTOP: 1439,
  };